import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import {
  PaginationGroup,
  LimitPaginationButton,
  EmptyState,
  ModalWindow,
  Loading
} from 'components/common/Elements/Elements';
import ChangeRole from './parts/ChageRole/ChangeRole';
import InputSearch from 'components/common/forms/InputSearch/InputSearch';
import UsersSettingsTable from './UsersSettingsTable/UsersSettingsTable';
import { modalActionBody } from 'components/common/Elements/NewModal/newModal';

import { showNotif } from 'utils/notification';
import { postRequest, deleteRequest } from 'utils/requests';
import { initialTableShow } from 'utils/settings';

import classes from './UsersSettings.module.scss';

const UsersSettings = () => {
  const [search, setSearch] = useState('');
  const [users, setUsers] = useState({});
  const [loader, setLoader] = useState(true);
  const [loaderTable, setLoaderTable] = useState(false);
  const [currentPage, setCurrentPage] = useState(initialTableShow.currentPage);
  const [itemsPerPage, setItemsPerPage] = useState(
    initialTableShow.itemsPerPage
  );
  const [fieldName, setFieldName] = useState('firstName');
  const [direction, setDirection] = useState(initialTableShow.direction * -1);
  const [modeModalRoles, setModeModalRoles] = useState(false);
  const [changeModalRoles, setChangeModalRoles] = useState({
    id: '',
    changeName: ''
  });
  const [dataConnection, setDataConnection] = useState(false);

  useEffect(() => {
    if (modeModalRoles) {
      document.body.classList.add(classes.bodyOnScroll);
    } else {
      document.body.classList.remove(classes.bodyOnScroll);
    }
  }, [modeModalRoles]);

  useEffect(() => {
    setLoaderTable(true);
    const url = `/settings/users/list?page=${currentPage}&limit=${itemsPerPage}`;
    const REQ_BODY = {
      search: search ? search : '*',
      sort: {
        fieldName: fieldName,
        direction: direction
      }
    };
    postRequest(url, REQ_BODY)
      .then(res => {
        setUsers(res.body);
        setDataConnection(true);
        setLoaderTable(false);
        setLoader(false);
      })
      .catch(err => {
        setLoader(false);
        console.log(err);
        setDataConnection(false);
        setLoaderTable(false);
      });
  }, [search, currentPage, itemsPerPage, loader, fieldName, direction]);

  const { t } = useTranslation('settings');

  const resetCurrentPage = () => {
    setCurrentPage(1);
  };

  const handleSortable = field => () => {
    if (field === fieldName) {
      const directionTemp = direction * -1;
      setDirection(directionTemp);
    } else {
      setFieldName(field);
    }
  };

  const handleManageRole = (_id, name, role, modalName) => {
    setChangeModalRoles({ id: _id, changeName: name, currentRole: role });
    if (modalName === 'role') {
      setModeModalRoles(true);
    } else if (modalName === 'del') {
      modalActionBody({
        title: t('settings:users.table.DELETE_CONFIRMATION_TITLE'),
        callBack: () => handleDeleteUser(changeModalRoles),
        text: t('settings:users.table.DELETE_CONFIRMATION', {
          changeName: name
        })
      });
    }
  };

  const handleDeleteUser = ({ id, name }) => {
    const url = `/settings/user/delete`;
    const REQ_BODY = {
      userId: id
    };
    deleteRequest(url, REQ_BODY)
      .then(() => {
        showNotif({
          message: t('settings:users.notif.USER_DELETED', { name }),
          kind: 'success',
          dismissAfter: 10000,
          type: 'alert'
        });
        setLoader(true);
      })
      .catch(err => {
        console.log(err);
        showNotif({
          message: t('settings:users.notif.USER_NOT_DELETED', { name }),
          kind: 'error',
          dismissAfter: 10000,
          type: 'alert'
        });
      });
  };

  const handleSearch = e => {
    if (search !== e.target.value) {
      resetCurrentPage(true);
      setSearch(e.target.value);
    }
  };

  const onClearSearch = () => {
    resetCurrentPage(true);
    setSearch('');
  };

  const handleLimitChange = limit => {
    if (itemsPerPage === limit) {
      return;
    }
    resetCurrentPage();
    setItemsPerPage(limit);
  };

  if (loader) {
    return <Loading />;
  }

  return (
    <>
      <ModalWindow
        headerText={`${t('settings:TITLE_CHANGE_ROLE')} ${
          changeModalRoles.changeName
        }`}
        setIsOpen={setModeModalRoles}
        isOpen={modeModalRoles}
      >
        <ChangeRole
          closeModal={() => setModeModalRoles(false)}
          info={changeModalRoles}
          setLoaderTable={setLoader}
        />
      </ModalWindow>
      <div className={classes.users}>
        <div className={classes.filters}>
          <InputSearch
            placeholder={t('activity:filters.SEARCH')}
            value={search}
            onChange={handleSearch}
            onClearSearch={onClearSearch}
            disabled={loaderTable}
          />
          <div className={classes.buttonWrap}>
            <LimitPaginationButton
              currentLimit={itemsPerPage}
              onLimitChange={handleLimitChange}
            />
          </div>
        </div>

        {dataConnection ? (
          users.data.length !== 0 ? (
            <>
              {loaderTable ? (
                <Loading />
              ) : (
                <UsersSettingsTable
                  tableData={users.data}
                  handleManageRole={handleManageRole}
                  handleDeleteUser={handleDeleteUser}
                  handleSortable={handleSortable}
                  direction={direction}
                  fieldName={fieldName}
                />
              )}

              {users.data && loaderTable === false && users.totalPages > 1 && (
                <PaginationGroup
                  pageCount={users.totalPages}
                  setPage={setCurrentPage}
                  currentPage={currentPage}
                  itemsTotal={users.totalRecords}
                  itemsPerPage={itemsPerPage}
                />
              )}
            </>
          ) : (
            <EmptyState />
          )
        ) : (
          <EmptyState message="connect" />
        )}
      </div>
    </>
  );
};

export default UsersSettings;
